import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {WindowStzhComponents} from '@oiz/stzh-components';
import {defineCustomElements} from '@oiz/stzh-components/loader';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const stzhBase = new URL('assets/stzh-components/', document.baseURI).href;
// Nur die vom Consumer zu setzenden Felder; der Stencil-Loader füllt die
// restlichen WindowStzhComponents-Felder (version, formats, utils, ...) bei
// defineCustomElements() selbst auf.
window.stzhComponents = {
  defaultLocale: 'de',
  pathMedia: `${stzhBase}assets/media`,
  pathTranslations: `${stzhBase}assets/i18n`,
  pathVendors: `${stzhBase}assets/vendors`,
} as WindowStzhComponents;

defineCustomElements(window, {resourcesUrl: stzhBase});

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
    .catch(err => console.error(err));